import script from "./ProductSearchItem.vue?vue&type=script&lang=js"
export * from "./ProductSearchItem.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__